<template>
  <div @click.stop.prevent="close" class="modal-back">
    <div @click.stop class="modal-inner">
      <div class="wrapper">
        <div
          class="close-btn"
          @click="close"
          data-shortcut-esc="chipsPopup"
        >
          <span></span>
        </div>
        <div>
          <div class="folders-wrapper" v-if="chipType === 'folder'">
            <ul
              class="folders"
            >
              <li
                v-for="(folder, index) in sortedFoldersData"
                :class="{ selected: folders.select === folder.id }"
                :key="index"
                @click="$emit('chipSelect', folder); close();"
              >
                {{ folder.name }}
              </li>
            </ul>
          </div>
          <div class="tags-wrapper" v-if="chipType === 'tag'">
            <ul
              class="tags"
            >
              <li
                v-for="(tag, index) in sortedTagsData"
                :class="{ selected: isTagSelected(tag) }"
                @click="$emit('chipSelect', tag)"
                :key="index"
              >
                {{tag.name}}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ShortCutBase from '@/mixins/ShortCutBase'
import { mixin as onClickAway } from 'vue-clickaway'

export default {
  props: {
    chipType: {
      type: String,
      required: true,
    },
    folders: {
      type: Object,
      required: false,
    },
    tags: {
      type: Object,
      required: false,
    },
  },
  mixins: [
    onClickAway,
    ShortCutBase,
  ],
  computed: {
    isTagSelected () {
      return function (tag) {
        if (tag.id === 'all') {
          return this.tags.selects === 'all'
        } else {
          return Array.isArray(this.tags.selects) && this.tags.selects.some(select => tag.id === select)
        }
      }
    },
    sortedFoldersData () {
      // グループ名が 未設定 > 選択されている > 選択されていない の順番でソートしています
      const [ unsetFoldersData, ...notUnsetFoldersData ] = this.folders.data
      const selectedFolders = notUnsetFoldersData.filter(folder => this.folders.select === folder.id)
      const notSelectedFolders = notUnsetFoldersData.filter(folder => this.folders.select !== folder.id)

      return unsetFoldersData == null ? [
        ...selectedFolders,
        ...notSelectedFolders,
      ] : [
        unsetFoldersData,
        ...selectedFolders,
        ...notSelectedFolders,
      ]
    },
    sortedTagsData () {
      // タグ名が 未設定 > 選択されている > 選択されていない の順番でソートしています
      const [ unsetTagsData, ...notUnsetTagsData ] = this.tags.data
      const selectedTags = notUnsetTagsData.filter(tag => this.isTagSelected(tag))
      const notSelectedTags = notUnsetTagsData.filter(tag => !this.isTagSelected(tag))
      return unsetTagsData == null ? [
        ...selectedTags,
        ...notSelectedTags,
      ] : [
        unsetTagsData,
        ...selectedTags,
        ...notSelectedTags,
      ]
    },
  },
  methods: {
    close () {
      this.$emit('close')
    },
  },
}
</script>

<style lang="scss" scoped>
.modal-inner {
  padding: 5px;
  width: 80vw;
  max-height: 80vh;
  overflow: auto;
  background-color: #F8F8F8;
  border-radius: 2px;
  position: relative;
  .close-btn {
    position: absolute;
    display: inline-block;
    width: 50px;
    height: 50px;
    top: 3px;
    right: 3px;
    border: none;
    cursor: pointer;
    background: none;
    outline: none;
    span::before, span::after {
      display: block;
      content: '';
      position: absolute;
      top: 50%;
      left: 50%;
      width: 25px;
      height: 3px;
      border-radius: 2px;
      margin: -1px 0 0 -13px;
      background: #000;
    }
    span::before {
      transform: rotate(-45deg);
    }
    span::after {
      transform: rotate(45deg);
    }
    &:hover {
      opacity: 0.7;
    }
  }
}
.wrapper {
  margin: 26px 40px 20px;
}

// フォルダへのリンク
.folders-wrapper {
  display:-webkit-box;
  display:flex;
  .folders {
    margin: 0;
    display:-webkit-box;
    display: flex;
    flex-wrap: wrap;
    transition: all 0.3s ease 0s;
    overflow: hidden;
    &::before {
      font-family: "Font Awesome 5 Free";
      content: '\f5fd';
      font-weight: 900;
    }
    &.open {
      overflow: none;
    }
    li {
      display: inline-block;
      cursor: pointer;
      margin: 0 10px 10px 0;
      transition: all 0.3s ease 0s;
      height: 24px;
      line-height: 24px;
      display: inline-block;
      padding: 0 10px;
      background: #fff;
      border-radius: 2px;
      &:hover {
        background: rgba($primaryHoverColor, 0.4);
      }
      &:first-of-type {
        margin-left: 10px;
      }
      &.selected {
        color: #fff;
        background: $primaryActiveColor;
        &:hover {
          background: $primaryHoverColor;
        }
      }
    }
  }
}
// タグ機能
.tags-wrapper {
  display:-webkit-box;
  display:flex;
  margin: 0 0 25px 20px;
  .tags {
    margin: 0;
    display:-webkit-box;
    display: flex;
    flex-wrap: wrap;
    transition: all 0.3s ease 0s;
    overflow: hidden;
    &::before {
      font-family: "Font Awesome 5 Free";
      content: '\f02b';
      font-weight: 900;
    }
    &.open {
      overflow: none;
    }
    li {
      height: 24px;
      line-height: 24px;
      display: inline-block;
      padding: 0 10px;
      cursor: pointer;
      margin: 0 10px 10px 0;
      background: #fff;
      border-radius: 12px;
      transition: all 0.3s ease 0s;
      &:first-of-type {
        margin-left: 10px;
      }
      &:hover {
        background: rgba($primaryHoverColor, 0.4);
      }
      &.selected {
        color: #fff;
        background: $primaryActiveColor;
        &:hover {
          background: $primaryHoverColor;
        }
      }
    }
  }
}
</style>
